import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Prompt, useHistory } from 'react-router'
import { useSetRecoilState } from 'recoil'
import { openModalState } from 'recoils/atoms'

import { Modal } from 'components'
import { Confirmation } from 'components/Modal'
import type { Location } from 'history'

interface Props {
  when: boolean
}

const PromptGuard: React.VFC<Props> = ({ when }: Props) => {
  const [isOpenConfirmation, setIsOpenConfirmation] = useState<boolean>(false)
  const [nextRoute, setNextRoute] = useState<string>()
  const setIsOpenModal = useSetRecoilState(openModalState)
  const history = useHistory()
  const { t } = useTranslation('common')

  const checkContentModal = document.getElementsByClassName('con-modal')

  const handleBlockNavigate = (location: Location): string | boolean => {
    setNextRoute(location.pathname)

    if (!isOpenConfirmation && checkContentModal.length === 0) {
      setIsOpenConfirmation(true)
      return false
    }

    return true
  }

  const handleClose = (nextRoute?: string) => {
    setIsOpenModal(false)
    nextRoute && history.push(nextRoute)
  }

  useEffect(() => {
    if (when) {
      window.onbeforeunload = () => ''
    }

    return () => {
      window.onbeforeunload = null
    }
  }, [when, checkContentModal])

  return (
    <>
      <Prompt when={when} message={handleBlockNavigate} />
      <Modal
        isOpen={isOpenConfirmation}
        isIcon={false}
        isPrompt
        onClose={() => setIsOpenConfirmation(false)}
      >
        <Confirmation
          title={t('confirmation.notSaveTitle.label')}
          description={t('confirmation.notSaveDescription.label')}
          confirmText={t('editNext.label')}
          cancelText={t('wantCancel.label')}
          onConfirm={() => setIsOpenConfirmation(false)}
          onClose={() => handleClose(nextRoute)}
        />
      </Modal>
    </>
  )
}

export default PromptGuard
